import React from "react";
import appLoggingApi from "../../../api/appLoggingApi";

class BuyNowErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    // Notify the server of unhandled exceptions in the purchase flow.
    appLoggingApi.sendException(error, errorInfo);
  }

  render() {
    return this.props.children;
  }
}

export default BuyNowErrorBoundary;